import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Fetcher from './Fetcher';
export var getClientIpAddress = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(quizSessionId) {
    var url, fetcher, _yield$fetcher$get, ip;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          url = "/api/quiz_sessions/".concat(quizSessionId, "/get_ip_address");
          fetcher = new Fetcher();
          _context.next = 5;
          return fetcher.get(url);
        case 5:
          _yield$fetcher$get = _context.sent;
          ip = _yield$fetcher$get.ip;
          return _context.abrupt("return", ip);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 10]]);
  }));
  return function getClientIpAddress(_x) {
    return _ref.apply(this, arguments);
  };
}();